export default __webpack_public_path__ + "static/media/logo.5d4bf63e.png";